export default "For images, random noise is just random pixel values that obscures image content.\n"